module.exports = __webpack_public_path__ + "img/6.32eba202.jpg";